module.exports = __webpack_public_path__ + "static/media/logo-white.be0ccc3d.svg";